import { render, staticRenderFns } from "./CoursesCategoryList.vue?vue&type=template&id=2430c49d"
import script from "./CoursesCategoryList.vue?vue&type=script&lang=js"
export * from "./CoursesCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports